<div class="card card-list-bg">
    <div class="card-header list-header d-flex justify-content-between">
        <h5 *ngIf="isLoading" class="loading"><span class="mdi mdi-bank-transfer" aria-hidden></span>
            Processing your request</h5>
        <h5 *ngIf="isMfaEnabled" class="loading"><span class="mdi mdi-bank-transfer" aria-hidden></span>
          MFA is Required to Process Payment</h5>
            <ng-container *ngIf="!isMfaEnabled">
              <h5 *ngIf="!isLoading && status == '00' && content == undefined"><span class="mdi mdi-bank-check  mr-1" aria-hidden></span>Payment Successful</h5>
              <h5 *ngIf="!isLoading && status != '00' && content == undefined && !isAchAdded && !isPaymentLinkRequest"><span class="mdi mdi-bank-check  mr-1" aria-hidden></span>Payment Declined</h5>
              <h5 *ngIf="!isLoading && status != '00' && content == undefined && !isAchAdded && isPaymentLinkRequest"><span class="mdi mdi-bank-check  mr-1" aria-hidden></span>Payment Link Not Generated</h5>
              <h5 *ngIf="!isLoading && status == undefined && content != undefined"><span class="mdi mdi-bank-check  mr-1" aria-hidden></span>Payment Link Generated</h5>
            </ng-container>
            <h5 *ngIf="isAchAdded == 'true' || isAchAdded == 'false'"><span class="mdi mdi-bank-check  mr-1" aria-hidden></span>Add Bank</h5>
            <!-- <h5><span class="mdi mdi-refresh mr-1" aria-hidden></span>Kindly don't refresh</h5> -->
    </div>
    <!-- <div class="card-body p-0" *ngIf="isLoading">
        <p-progressBar mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
    </div> -->
    <div class="card-body">
        <!-- <app-loading *ngIf="isLoading"></app-loading> -->
        <div class="text-center m-5 p-5" *ngIf="isLoading">
            <div class="spinner-border text-success" style="height: 5.5rem;width: 5.5rem;"role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <div class="text-center" *ngIf="isAchAdded =='true'">
          <!-- <i data-feather="check-circle" appFeatherIcon class="text-success mt-4 mb-2 icon-xxl"></i> -->
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
            <circle class="path circle" fill="none" stroke="#10b759" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1"
              r="62.1" />
            <polyline class="path check" fill="none" stroke="#10b759" stroke-width="6" stroke-linecap="round"
              stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
          </svg>
          <h3 class="text-muted mt-1 mb-3">Success!</h3>
          <div *ngIf="validateCard != true">
            <p class="w-75 mx-auto mb-2 text-muted">The bank has been successfully added to the customer.</p>
          </div>
          </div>
        <div class="text-center" *ngIf="isAchAdded =='false'">
          <!-- <i data-feather="check-circle" appFeatherIcon class="text-success mt-4 mb-2 icon-xxl"></i> -->
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
            <circle class="path circle" fill="none" stroke="#ff3366" stroke-width="6" stroke-miterlimit="10" cx="65.1"
              cy="65.1" r="62.1" />
            <line class="path line" fill="none" stroke="#ff3366" stroke-width="6" stroke-linecap="round"
              stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
            <line class="path line" fill="none" stroke="#ff3366" stroke-width="6" stroke-linecap="round"
              stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" />
          </svg>
          <h3 class="text-muted mt-1 mb-1">Failed!</h3>
          <div>
            <p class="w-75 mx-auto mb-2 text-muted">{{errorMessage?.length ? errorMessage : "We couldn't add the bank account. Please try again."}}</p>
          </div>
          </div>
        <div *ngIf="!isMfaEnabled">
          <!-- Condent displayed on successful payment  -->
          <div class="text-center" *ngIf="!isLoading && status == '00'  && content == undefined && !isAchAdded">
            <!-- <i data-feather="check-circle" appFeatherIcon class="text-success mt-4 mb-2 icon-xxl"></i> -->
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
              <circle class="path circle" fill="none" stroke="#10b759" stroke-width="6" stroke-miterlimit="10" cx="65.1"
                cy="65.1" r="62.1" />
              <polyline class="path check" fill="none" stroke="#10b759" stroke-width="6" stroke-linecap="round"
                stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
            </svg>
            <h3 class="text-muted mt-1 mb-3">Approved !</h3>
            <div *ngIf="validateCard != true">
              <p class="w-75 mx-auto mb-2 text-muted">Your <b>{{paymentMode === 'Bank' ? 'ACH' : paymentMode}} {{transactionType | titlecase}}</b> transaction of
                <b>{{(amount/100)| currency}}</b> has been processed successfully.</p>
              <p class="w-75 mx-auto mb-2 text-muted" *ngIf="isEmail">Receipt has been sent to <b><span
                    class="mdi mdi-email-check  mr-1" aria-hidden></span> {{isEmail}}</b></p>
              <p class="w-75 mx-auto mb-2 text-muted" *ngIf="isPhoneNumber">Sms has been sent to <b><span
                    class="mdi mdi-cellphone-message mr-1" aria-hidden></span>{{isPhoneNumber}}</b></p>
              <p class="w-75 mx-auto mb-2 text-muted" *ngIf="customField?.isRespMessage"><b>Response : <span class="mr-1"
                    aria-hidden></span>{{customField?.isRespMessage}}</b></p>
              <p class="w-75 mx-auto mb-2 text-muted" *ngIf="issurcharge == true"> {{customLabel}} not added for this
                transaction</p>
              <p class="w-75 mx-auto mb-2 text-muted" *ngIf="isTCDF == true"> <b>{{customLabel}}</b></p>
              <p class="w-75 mx-auto mb-2 text-muted" *ngIf="isTCDF == true">You saved <b>{{(savedAmt/100)| currency}}</b></p>
              <p class="w-75 mx-auto mb-2 text-muted" *ngIf="isDCDF == true"> <b>{{customLabel}}</b></p>
            </div>
            <p class="w-75 mx-auto mb-2 text-muted" *ngIf="validateCard == true">Card has been validated successfully</p>
            <p class="w-75 mx-auto mb-2 text-muted" *ngIf="isCashChange">Change due : <b>{{ cashChange | currency}}</b></p>
          </div>
          <!-- Condent displayed on payment failure -->
          <div class="text-center" *ngIf="!isLoading && status != '00' && content == undefined && !isAchAdded">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
              <circle class="path circle" fill="none" stroke="#ff3366" stroke-width="6" stroke-miterlimit="10" cx="65.1"
                cy="65.1" r="62.1" />
              <line class="path line" fill="none" stroke="#ff3366" stroke-width="6" stroke-linecap="round"
                stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
              <line class="path line" fill="none" stroke="#ff3366" stroke-width="6" stroke-linecap="round"
                stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" />
            </svg>
            <!-- <i data-feather="x-circle" appFeatherIcon class="text-danger mt-4 mb-2 icon-xxl"></i> -->
            <p class="text-danger text-muted mb-3" *ngIf="validateCard != false && validateCard != true && !isPaymentLinkRequest">Declined Transaction
            </p>
            <p class="text-danger text-muted mb-3" *ngIf="paymentFailureText">Sending payment link failed</p>
            <p class="w-75 mx-auto mb-4 text-muted" *ngIf="validateCard != true">Reason <b>{{errorMessage}}</b></p>
            <p class="text-danger text-muted mb-3" *ngIf="validateCard == true">Declined Validation</p>
            <p class="text-danger text-muted mb-3" *ngIf="validateCard == true">Your card validation is failed</p>
          </div>
          <!-- Content display while send link processed-->
          <div class="text-center" *ngIf="!isLoading && content != undefined">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" class="mb-4">
              <circle class="path circle" fill="none" stroke="#10b759" stroke-width="6" stroke-miterlimit="10" cx="65.1"
                cy="65.1" r="62.1" />
              <polyline class="path check" fill="none" stroke="#10b759" stroke-width="6" stroke-linecap="round"
                stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
            </svg>
            <p class="w-75 mx-auto mb-2 text-muted" *ngIf="isEmail">Email has been sent to <b><span
                  class="mdi mdi-email-check  mr-1" aria-hidden></span> {{isEmail}}</b></p>
            <p class="w-75 mx-auto mb-2 text-muted" *ngIf="isPhoneNumber">Sms has been sent to <b><span
                  class="mdi mdi-cellphone-message mr-1" aria-hidden></span>{{isPhoneNumber}}</b></p>
        
        
          </div>
          <div class="text-center" *ngIf="isL2L3Applicable">
            <ng-container *ngIf="!isL2L3Error else l2l3error">
              <p-message severity="warn" *ngIf="isL2L3Loading" text="Uploading Level 2 and Level 3 Details"></p-message>
              <p-message severity="success" *ngIf="!isL2L3Loading" text="Successfully uploaded Level 2 and Level 3 details !">
              </p-message>
            </ng-container>
            <ng-template #l2l3error>
              <p-message severity="error" [text]="L2L3ErrorMessage"> </p-message>
            </ng-template>
        
            <p class="w-75 mx-auto mb-2 text-muted"> </p>
            <p class="w-75 mx-auto mb-2 text-muted"> </p>
          </div>
          <div class="text-center" *ngIf="isLineItemEnabled">
            <ng-container *ngIf="!isLineItemError else errorQB">
              <p-message severity="warn" *ngIf="!isLineItemProcessed" text="Uploading Quick Book Details"></p-message>
              <p-message severity="success" *ngIf="isLineItemProcessed" [text]="qbSuccessMessage">
              </p-message>
            </ng-container>
            <ng-template #errorQB>
              <p-message severity="error" [text]="lineItemErrorMessage"> </p-message>
            </ng-template>
            <p class="w-75 mx-auto mb-2 text-muted"> </p>
          </div>
          <div class="text-center" *ngIf="isExternalInvoiceUpdate">
            <ng-container *ngIf="!isExternalInvoiceUpdateError else externalInvoiceUpdateError">
              <p-message severity="warn" *ngIf="!isExternalInvoiceUpdated" text="Updating invoice..."></p-message>
              <p-message severity="success" *ngIf="isExternalInvoiceUpdated" text="Invoice updated"></p-message>
            </ng-container>
            <ng-template #externalInvoiceUpdateError>
              <p-message severity="error" [text]="externalInvoiceUpdateErrorMessage"></p-message>
              <p class="w-75 mx-auto mt-2 mb-0 text-muted" *ngIf="externalInvoiceTxnId">Ref : {{ externalInvoiceTxnId }}
                <button type="button" class="btn btn-link btn-sm p-0 ml-1" title="Copy reference"
                  (click)="copyExternalInvoiceTxnId()" ngbPopover="Copied" triggers="click">
                  <span class="mdi mdi-content-copy" aria-hidden></span>
                </button>
              </p>
            </ng-template>
            <p class="w-75 mx-auto mb-2 text-muted"> </p>
          </div>
          <div class="text-center" *ngIf="isFortellisEnabled">
            <ng-container>
              <p-message severity="warn" *ngIf="!isFortellisProcessed"
                text="Uploading invoice payment to Fortellis DMS"></p-message>
              <p-message severity="success" *ngIf="isFortellisProcessed" [text]="fortSuccessMessage">
              </p-message>
              <p class="w-75 mx-auto mb-2 text-muted" *ngIf="isFortellisProcessed">Invoice status will be updated shortly.</p>
            </ng-container>
          </div>
        </div>
        <app-multi-factor-auth *ngIf="isMfaEnabled" widthClass="col-md-12 col-xl-12" (afterSuccessVerifyOtp)="afterSuccessVerifyOtp($event)" native="component" [title]="mfaTitle" [content]="mfaContent" [mfaData]="mfaData" [apiName]="apiName" [formData]="formData" [showBackButton]="showBackButton" (onBack)="onBack($event)" [httpOptions]="httpOptions"></app-multi-factor-auth>

</div>

    <div [ngClass]="commonService.isMobileView ? 'row top-width' : 'd-flex'" class="card-footer justify-content-end" *ngIf="!isLoading && !isMfaEnabled">
        <div class=" text-center" [ngClass]="commonService.isMobileView ? 'mb-2 mx-2' : ''">
          <button (click)="copyLink()" *ngIf="paymentLink != undefined" triggers="click" ngbPopover="Copied" class="btn btn-light mr-2"><i data-feather="copy" class="icon-sm mb-1"></i>Copy Link</button>
          <button (click)="onClose()" class="btn btn-outline-danger" [disabled]="isExternalInvoiceUpdating" [attr.title]="isExternalInvoiceUpdating ? 'Invoice is updating, please wait' : null">Close</button>
        </div>
        <div class="text-center" *ngIf="status == '00' && transactionId">
          <button type="button" class="btn btn-primary mx-2" (click)="openViewReceipt('MC')" [disabled]="isExternalInvoiceUpdating"> Merchant Copy</button>
          <button type="button" class="btn btn-primary" (click)="openViewReceipt('CC')" [disabled]="isExternalInvoiceUpdating"> Customer Copy</button>
        </div>
    </div>
</div>